import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { initPortalTheme } from './utils/portalTheme'
import { loadFonts } from './plugins/webfontloader'
import store from './store'
import router from './router'
import { Amplify } from 'aws-amplify'
import { getAmplifyConfig } from './config/portalEnvironment'

// Vuetify/dialog resize observers can trigger benign dev overlay noise in Firefox.
if (typeof window !== 'undefined') {
  const ignoreResizeObserverLoop = (message = '') =>
    String(message).includes('ResizeObserver loop')

  window.addEventListener('error', (event) => {
    if (ignoreResizeObserverLoop(event.message)) {
      event.stopImmediatePropagation()
    }
  })

  const originalConsoleError = window.console.error
  window.console.error = (...args) => {
    const first = args[0]
    const message = typeof first === 'string' ? first : first?.message
    if (ignoreResizeObserverLoop(message)) return
    originalConsoleError(...args)
  }
}

loadFonts()
initPortalTheme(vuetify)

Amplify.configure(getAmplifyConfig())

createApp(App).use(router).use(store).use(vuetify).mount('#app')
